<template>
	<div>
		<div v-for="(goal, i) in studentGoals" :key="i">
			<div class="goal-name">{{ goal.cmsGoal.name }}</div>
		</div>
	</div>
</template>
<script>
export default {
	computed: {
		studentGoals() {
			return this.$store.getters.lifeStageData.studentGoals.filter(
				x => x.cmsGoal
			);
		}
	}
};
</script>
<style lang="scss" scoped>
.goal-name {
	text-transform: capitalize;
	font-family: 'RobotoRegular';
	font-size: 14px;
	line-height: 23px;
	color: $font-header;

	&:not(:last-child) {
		margin-bottom: 8px;
	}

	@media (min-width: $breakpoint-mid) {
		font-size: 16px;
	}
}
</style>
